export const PRIVACY_CATEGORIES = [
    'online',
    'friends',
    'personalInfo',
    'favorites',
    'messages',
    'calls',
];
/** Базовое правило по умолчанию — всё видно всем (текущее поведение сервиса). */
export const DEFAULT_PRIVACY_RULE = { visibility: 'everyone', allow: [], deny: [] };
/** Дефолтные настройки приватности (каждая категория — «видно всем»). */
export function defaultPrivacySettings() {
    return {
        online: { visibility: 'everyone', allow: [], deny: [] },
        friends: { visibility: 'everyone', allow: [], deny: [] },
        personalInfo: { visibility: 'everyone', allow: [], deny: [] },
        favorites: { visibility: 'everyone', allow: [], deny: [] },
        messages: { visibility: 'everyone', allow: [], deny: [] },
        calls: { visibility: 'everyone', allow: [], deny: [] },
    };
}
export const ALL_PERMISSIONS = {
    canPlayPause: true,
    canSeek: true,
    canSetVideoUrl: true,
    canManagePlaylist: true,
};
export const DEFAULT_MEMBER_PERMISSIONS = {
    canPlayPause: true,
    canSeek: true,
    canSetVideoUrl: false,
    canManagePlaylist: false,
};
export const DEFAULT_GUEST_PERMISSIONS = {
    canPlayPause: false,
    canSeek: false,
    canSetVideoUrl: false,
    canManagePlaylist: false,
};
/** Больше снимков в одном сообщении не отправить. */
export const DM_MAX_IMAGES = 10;
// ── Voice/video call ────────────────────────────────────────────────────
/** Cap on simultaneous voice participants in one room's call. */
export const CALL_MAX_VOICE = 10;
/** Cap on simultaneous video tracks (a video slot also occupies a voice slot). */
export const CALL_MAX_VIDEO = 4;
/** Сколько идёт дозвон, прежде чем звонок станет пропущенным. */
export const DM_CALL_RING_MS = 45_000;
//# sourceMappingURL=domain.js.map